export default {
	NONE: '',
	CHANGED: 'changed',
	SAVING: 'saving',
}
